module.exports = __webpack_public_path__ + "static/media/honeywood.6cd9a7a9.png";